import axios from "axios";
import { EXPRESS_BASE_URL } from "./apiConfig";

// Giriş yapan kullanıcıyı Express'teki kullanıcı izleme tablosuna bildirir.
// Normal giriş ve Google girişi ortak kullanıyor (önceden Login.js içindeydi).
export const traceUserLogin = async (authData) => {
    try {
        const userInfo = authData.user || authData.User;
        const userDetail = authData.detail || authData.Detail;

        const userId = userInfo?.id;
        const fullName = userInfo?.fullName;
        const schoolId = userDetail?.schoolId;

        let mappedRole = "";
        if (userInfo?.isManager) mappedRole = "manager";
        else if (userInfo?.isStudent) {
            mappedRole = userInfo?.isIndividual ? "schoolstudent" : "individualstudent";
        } else if (userInfo?.roleName === "Teacher") mappedRole = "teacher";
        else mappedRole = "admin";

        await axios.post(EXPRESS_BASE_URL + "/api/user-trace/ping", {
            userId: userId,
            schoolId: schoolId || null,
            fullName: fullName,
            userType: mappedRole
        });
    } catch (e) {
        console.error("Trace Hatası:", e);
    }
};
